// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tab {
  cursor: default;
  border: 0;
  border-radius: 1px 25px 1px 0px;
  line-height: 16px;
  height: 19px;
  white-space: nowrap;
  font-size: 13px;
  font-weight: 400;
  background-color: #a3b9d9;
  padding: 0 0.9em 0 1.1em;
  justify-content: space-between;
  display: flex;
  align-items: center;
  width: auto;
  min-width: max-content;
  box-sizing: border-box;
}
.tab .container {
  position: relative;
  padding-right: 1em;
  white-space: nowrap;
  min-width: max-content;
  flex: 0 0 auto;
}
.tab:focus {
  outline: none;
}
.tab.selected {
  background-color: #f5f5f5;
  opacity: 1;
  color: #567db8;
  border: 1px solid #a3b9d9;
  border-bottom: 0;
}
.tab:not(.selected) {
  cursor: pointer;
}
.tab:first-of-type {
  border-left: 0.5rem solid #a3b9d9;
}
.tab .title {
  margin-right: 1em;
  white-space: nowrap;
}
.tab .tab-close-btn {
  width: 1.7rem;
  text-align: center;
  cursor: pointer;
  position: absolute;
  right: 0;
  z-index: 10;
}
.tab .tab-close-btn:hover {
  opacity: 0.9;
  border-radius: 8px;
  background-color: rgba(128, 128, 128, 0.175);
  box-shadow: rgba(0, 0, 0, 0.118) 0px 19px 38px, rgba(0, 0, 0, 0.09) 0px 15px 12px;
}

.tabs-title-container {
  position: absolute;
  top: -19px;
  margin-left: -0.5rem;
  display: flex;
}

.tab-container {
  position: absolute;
  top: -19px;
  margin-left: -0.5rem;
  display: flex;
  align-items: center;
  overflow: hidden;
  width: calc(100% + 1rem);
}

.tabs-wrapper {
  overflow: hidden;
  flex-grow: 1;
}

.tabs {
  display: flex;
  transition: transform 0.3s;
}

.scroll-btn {
  background-color: #f1f1f1;
  border: none;
  cursor: pointer;
  line-height: 16px;
  height: 19px;
  white-space: nowrap;
  font-size: 13px;
}

.scroll-btn:hover {
  background-color: #ddd;
}`, "",{"version":3,"sources":["webpack://./src/Components/conteiners/tabs/utils/tabs.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,SAAA;EACA,+BAAA;EACA,iBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,wBAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EAEA,WAAA;EACA,sBAAA;EACA,sBAAA;AAAF;AAEE;EACE,kBAAA;EACA,kBAAA;EAEA,mBAAA;EACA,sBAAA;EACA,cAAA;AADJ;AAIE;EACE,aAAA;AAFJ;AAIE;EACE,yBAAA;EACA,UAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;AAFJ;AAIE;EACE,eAAA;AAFJ;AAIE;EACE,iCAAA;AAFJ;AAIE;EACE,iBAAA;EACA,mBAAA;AAFJ;AAIE;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;AAFJ;AAGI;EACE,YAAA;EACA,kBAAA;EACA,4CAAA;EACA,iFAAA;AADN;;AAMA;EACE,kBAAA;EACA,UAAA;EACA,oBAAA;EACA,aAAA;AAHF;;AAMA;EACE,kBAAA;EACA,UAAA;EACA,oBAAA;EAEA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,wBAAA;AAJF;;AAOA;EACE,gBAAA;EACA,YAAA;AAJF;;AAOA;EACE,aAAA;EACA,0BAAA;AAJF;;AAMA;EACE,yBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;AAHF;;AAMA;EACE,sBAAA;AAHF","sourcesContent":[".tab {\n  cursor: default;\n  border: 0;\n  border-radius: 1px 25px 1px 0px;\n  line-height: 16px;\n  height: 19px;\n  white-space: nowrap;\n  font-size: 13px;\n  font-weight: 400;\n  background-color: #a3b9d9;\n  padding: 0 0.9em 0 1.1em;\n  justify-content: space-between;\n  display: flex;\n  align-items: center;\n\n  width: auto;\n  min-width: max-content;\n  box-sizing: border-box;\n\n  .container {\n    position: relative;\n    padding-right: 1em;\n    //! Safari fix???\n    white-space: nowrap;\n    min-width: max-content;\n    flex: 0 0 auto;\n  }\n\n  &:focus {\n    outline: none;\n  }\n  &.selected {\n    background-color: #f5f5f5;\n    opacity: 1;\n    color: #567db8;\n    border: 1px solid #a3b9d9;\n    border-bottom: 0;\n  }\n  &:not(.selected) {\n    cursor: pointer;\n  }\n  &:first-of-type {\n    border-left: 0.5rem solid #a3b9d9;\n  }\n  .title {\n    margin-right: 1em;\n    white-space: nowrap;\n  }\n  .tab-close-btn {\n    width: 1.7rem;\n    text-align: center;\n    cursor: pointer;\n    position: absolute;\n    right: 0;\n    z-index: 10;\n    &:hover {\n      opacity: 0.9;\n      border-radius: 8px;\n      background-color: rgba(128, 128, 128, 0.175);\n      box-shadow: rgba(0, 0, 0, 0.118) 0px 19px 38px, rgba(0, 0, 0, 0.09) 0px 15px 12px;\n    }\n  }\n}\n\n.tabs-title-container {\n  position: absolute;\n  top: -19px;\n  margin-left: -0.5rem;\n  display: flex;\n}\n\n.tab-container {\n  position: absolute;\n  top: -19px;\n  margin-left: -0.5rem;\n\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n  width: calc(100% + 1rem);\n}\n\n.tabs-wrapper {\n  overflow: hidden;\n  flex-grow: 1;\n}\n\n.tabs {\n  display: flex;\n  transition: transform 0.3s;\n}\n.scroll-btn {\n  background-color: #f1f1f1;\n  border: none;\n  cursor: pointer;\n  line-height: 16px;\n  height: 19px;\n  white-space: nowrap;\n  font-size: 13px;\n}\n\n.scroll-btn:hover {\n  background-color: #ddd;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
